import React from 'react';
import { Helmet } from 'react-helmet';

export const Seo = ({pageTitle, metaKeywords, metaDescription}) => (
	<Helmet
		titleTemplate="SwazerLab | %s"
	>
		<meta name="description" content={metaDescription} />
		<meta name="keywords" content={metaKeywords}/>
		<title>{pageTitle}</title>
	</Helmet>
);



// WEBPACK FOOTER //
// ./src/components/ui/Seo/Seo.js